import React, { useEffect, useState } from "react";
import { SET_LOADING } from "../redux/user";
import { useDispatch } from "react-redux";
import { api_paths } from "../config/api.paths";
import { toastErrorMessage } from "../utils/utils";
import API from "../config/axios";
import { Col, Container, Row } from "react-bootstrap";

const AboutUs = () => {
  const [page, setPage] = useState();
  const dispatch = useDispatch();

  const getPageDetails = async (identifier) => {
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(`${api_paths.GET_CMS_PAGE}${identifier}`);
      if (response?.data?.payload?.result) {
        setPage(response?.data?.payload?.result);
      }
    } catch (error) {
      console.log(error);
      toastErrorMessage(error?.response?.data?.message);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  useEffect(() => {
    getPageDetails("ABOUTUS"); // ABOUTUS term_condition about_us
    //eslint-disable-next-line
  }, []);

  return (
    <Container className="cms-sections">
      <Row className="text-center pt-4 pb-2">
        <Col lg={12}>
          <h1 className="mb-3 h1 text-main">About Us</h1>
          <p className="mb-0">
            Celebrating over four decades of cultural heritage and community
          </p>
        </Col>
      </Row>
      <hr />
      <Row className="pt-3">
        <Col lg={12}>
          <div
            className="cms_pages"
            style={{ background: "#ffffff" }}
            dangerouslySetInnerHTML={{ __html: page?.content }}
          ></div>
        </Col>
      </Row>
      <Row className="our-mission px-4 mx-auto py-4 mb-5">
        <Col lg={12} className="mb-4">
          <h3 className="mb-3">Our Mission</h3>
          <p className="mx-auto mb-0 text-muted">
            The Gujarati Samaj of Tampa Bay continues to serve as a bridge
            between generations, preserving and celebrating our rich cultural
            heritage while fostering unity, love, and community spirit among
            Gujaratis in the Tampa Bay area and beyond.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutUs;
